var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[(_vm.branch)?_c('ContentSection',{attrs:{"title":"Gallery"}},[_c('ImageGallery',{attrs:{"object-id":_vm.branch.BusinessBranchId,"object-type":"truemarket.Core.Collections.BusinessBranch"}})],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }